import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { AppInterceptor } from '../app.interceptor';

import { NgPipesModule } from 'ngx-pipes';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxPaginationModule } from 'ngx-pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { SuiModule } from 'ng2-semantic-ui';
import { MyDatePickerModule } from 'mydatepicker';
import { NgxUpperCaseDirectiveModule } from 'ngx-upper-case-directive';

import { AlertComponent } from './components/alert/alert.component';
import { FormDebugComponent } from './components/form-debug/form-debug.component';
import { RatingComponent } from './components/rating/rating.component';
import { ServiceUnavailableComponent } from './components/service-unavailable/service-unavailable.component';
import { ValidationsMessagesComponent } from './components/validations-messages/validations-messages.component';

import { AutoFocusDirective } from './directives/auto-focus/auto-focus.directive';
import { CollapsibleDirective } from './directives/collapsible/collapsible.directive';
import { DropdownDirective } from './directives/dropdown/dropdown.directive';
import { TabDirective } from './directives/tab/tab.directive';

import { BarChartService } from './services/charts/bar-chart/bar-chart.service';
import { CryptoJsService } from './services/crypto-js/crypto-js.service';
import { DateTimeService } from './services/date-time/date-time.service';
import { NotifyService } from './services/notify/notify.service';
import { LineChartService } from './services/charts/line-chart/line-chart.service';
import { PieChartService } from './services/charts/pie-chart/pie-chart.service';
import { SweetAlertService } from './services/sweet-alert/sweet-alert.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NgPipesModule,
    QRCodeModule,
    NgxPaginationModule,
    PopoverModule,
    SuiModule,
    MyDatePickerModule,
    NgxUpperCaseDirectiveModule,
  ],
  declarations: [
    AlertComponent,
    FormDebugComponent,
    RatingComponent,
    ServiceUnavailableComponent,
    ValidationsMessagesComponent,

    AutoFocusDirective,
    CollapsibleDirective,
    DropdownDirective,
    TabDirective,
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    NgPipesModule,
    QRCodeModule,
    NgxPaginationModule,
    PopoverModule,
    SuiModule,
    MyDatePickerModule,
    RouterModule,
    NgxUpperCaseDirectiveModule,

    AlertComponent,
    FormDebugComponent,
    RatingComponent,
    ServiceUnavailableComponent,
    ValidationsMessagesComponent,

    AutoFocusDirective,
    CollapsibleDirective,
    DropdownDirective,
    TabDirective,
  ],
  providers: [
    NotifyService,
    SweetAlertService,
    DateTimeService,
    BarChartService,
    LineChartService,
    PieChartService,
    CryptoJsService,
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true }
  ]
})
export class SharedModule { }
